import { render, staticRenderFns } from "./MenuLinks.vue?vue&type=template&id=0163e004&scoped=true&"
import script from "./MenuLinks.vue?vue&type=script&lang=js&"
export * from "./MenuLinks.vue?vue&type=script&lang=js&"
import style0 from "./MenuLinks.vue?vue&type=style&index=0&id=0163e004&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0163e004",
  null
  
)

export default component.exports